module.exports = __webpack_public_path__ + "img/bannerText.9f745e2c.png";